import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';

import { useProductWizardContext } from '../../product-wizard';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';

export const UpdateItemCta = () => {
  const { formatMessage } = useIntl();

  const { clearSlotsSelectionSnapshot } = useProductWizardContext();
  const { goToPreviousStep } = useProductWizardFlow();

  const handleSubmit = () => {
    clearSlotsSelectionSnapshot();
    goToPreviousStep();
  };

  return (
    <ActionButton testID="product-customization-action-button" flex={1} onPress={handleSubmit}>
      {formatMessage({ id: 'updateItem' })}
    </ActionButton>
  );
};
